// テンプレート編集フォームで使うバリデーション関数群。
// @mantine/form の validate にそのまま渡せるよう、エラーなしは undefined を返す
// （Mantine は undefined / null / false をエラーなしとして扱う）。

/** アップロード画像として受け付ける MIME タイプ */
export const IMAGE_MIME_TYPES = 'image/jpeg, image/png'

export type Validator = (value: any, values?: any, path?: string) => string | undefined

/**
 * 複数のバリデータを左から順に評価し、最初のエラーを返す
 */
export const composeValidators =
  (...validators: Validator[]): Validator =>
    (value, values, path) => {
      for (const validate of validators) {
        const error = validate(value, values, path)
        if (error !== undefined) return error
      }
      return undefined
    }

/** 必須。0 は未入力として扱う（デザインテンプレート種別・ロゴなど） */
export const required: Validator = (value) => (value ? undefined : '必須です')

/** 必須。0 を入力済みとして扱う（1回のシェアで紹介できる人数・公開期間など） */
export const requiredAllowZero: Validator = (value) =>
  value || value === 0 ? undefined : '必須です'

/** 最大文字数 */
export const maxChar =
  (max: number): Validator =>
    (value) =>
      value && value.length > max ? `${max}文字以内で設定してください` : undefined

/** 数値であること。未入力は許容する */
export const isNumber: Validator = (value) =>
  value && isNaN(Number(value)) ? '数字で入力してください' : undefined

/** 数値かつ0以上であること。未入力は許容する */
export const isNonNegativeNumber: Validator = (value) => {
  const error = isNumber(value)
  if (error) return error
  return Number(value) < 0 ? 'マイナスの数字は入力できません' : undefined
}

/** URL形式であること。未入力は許容する */
export const isUrl: Validator = (value) => {
  if (value) {
    const res = value.match(
      /^http(s)?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g,
    )
    if (!res) return '存在するURLを設定してください'
  }
  return undefined
}

/**
 * アップロード画像の形式チェック。
 * 保存済みURL（文字列）と未設定は許容する。
 * 空配列でも落ちないよう、GuestTemplateEditor 版のガード付き実装に揃えている
 */
export const isImage: Validator = (file) => {
  if (file && file[0] && file[0].type && !IMAGE_MIME_TYPES.includes(file[0].type)) {
    return '正しい画像ファイルを設定してください'
  }
  return undefined
}
